import { h } from 'preact';

export default function Error404() {
  return (
    <div className="empty">
      <p className="empty-title h5">Error 404 - Page Not Found!</p>
      <p className="empty-subtitle">The page you requested was not found. Please check the URL and try again.</p>
    </div>
  );
}
